// i18n.js
import i18n from "i18next";
import { add, over, remove } from "lodash";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      welcome: "Welcome to Candyland Adventure!",
      over_18: "You must be 18 or older to sign the waiver.",
      parent_info: "Adult/Guardian Information",
      parent_first_name: "Parent's First Name",
      parent_last_name: "Parent's Last Name",
      DOB_parent: "Parent's DOB",
      parent_email: "Email",
      parent_phone: "Phone Number",
      child_info: "Minor's Information",
      address: "Address",
      city: "City",
      state: "State",
      zip: "Zip Code",
      add_minor: "Add Minor",
      add_a_minor: "Add a Minor",
      first_name: "First Name",
      last_name: "Last Name",
      DOB: "Birthday",
      relation: "Relation",
      jan: "January",
      feb: "February",
      mar: "March",
      apr: "April",
      may: "May",
      jun: "June",
      jul: "July",
      aug: "August",
      sep: "September",
      oct: "October",
      nov: "November",
      dec: "December",
      son: "Son",
      daughter: "Daughter",
      cousin: "Cousin",
      others: "Others",
      close: "Close",
      add: "Add",
      remove: "Remove",
      next: "Next",
      submit: "Submit",
      back: "Back",
      clear: "Clear",
      sign: "Sign",
    },
  },
  es: {
    translation: {
      welcome: "¡Bienvenido a Candyland Adventure!",
      over_18: "Debe tener 18 años o más para firmar la exención.",
      parent_info: "Información para adultos/tutores",
      parent_first_name: "Nombre del padre",
      parent_last_name: "Apellido del padre",
      DOB_parent: "cumpleaños de los padres",
      parent_email: "correo electrónico de los padres",
      parent_phone: "Número de teléfono de los padres",
      child_info: "Información del menor",
      address: "Dirección",
      city: "Ciudad",
      state: "Estado",
      zip: "Código postal",
      add_minor: "Agregar menor",
      add_a_minor: "Agregar un menor",
      first_name: "Nombre",
      last_name: "Apellido",
      DOB: "Fecha de nacimiento",
      relation: "Relación",
      jan: "Enero",
      feb: "Febrero",
      mar: "Marzo",
      apr: "Abril",
      may: "Mayo",
      jun: "Junio",
      jul: "Julio",
      aug: "Agosto",
      sep: "Septiembre",
      oct: "Octubre",
      nov: "Noviembre",
      dec: "Diciembre",
      son: "Hijo",
      daughter: "Hija",
      cousin: "Primo",
      others: "Otros",
      close: "Cerrar",
      add: "Agregar",
      remove: "Eliminar",
      next: "Siguiente",
      submit: "Enviar",
      back: "Atrás",
      clear: "Claro",
      sign: "Firmar",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en", // default language
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
